// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6b759d06","789":"6f284bfe"}[chunkId] + ".chunk.js";
};